import { render, staticRenderFns } from "./PartnerContract.vue?vue&type=template&id=66c96b64&"
import script from "./PartnerContract.vue?vue&type=script&lang=ts&"
export * from "./PartnerContract.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports